/**
 * Alignment Titles System
 * 
 * This file contains 200 alignment titles spaced evenly from -100000 to +100000
 */

// Fix: Modify the generateAlignmentTitles function
const generateAlignmentTitles = () => {
  // Create empty titles object
  const titles = {};
  
  // Explicitly add all the title entries - no changes to your existing title definitions
  titles[-100000] = "Absolutely Diabolical";
  titles[-99000] = "Soul of Pure Darkness";
  titles[-90000] = "Harbinger of Doom";
  titles[-89000] = "Architect of Suffering";
  titles[-88000] = "Nightmare Incarnate";
  titles[-87000] = "Void's Champion";
  titles[-86000] = "Despair's Herald";
  titles[-85000] = "Tormentor Supreme";
  titles[-84000] = "Darkness Personified";
  titles[-83000] = "Corruption's Avatar";
  titles[-82000] = "Malevolence Manifest";
  titles[-81000] = "Bringer of Calamity";
  titles[-80000] = "Abyssal Monarch";
  titles[-79000] = "Malice Embodied";
  titles[-78000] = "Soul Devourer";
  titles[-77000] = "Cruelty's Master";
  titles[-76000] = "Dread Sovereign";
  titles[-75000] = "Chaos Sower";
  titles[-74000] = "Vile Oppressor";
  titles[-73000] = "Terror's Voice";
  titles[-72000] = "Venom's Heart";
  titles[-71000] = "Damnation's Hand";
  titles[-70000] = "Wicked Tyrant";
  titles[-69000] = "Misery's Architect";
  titles[-68000] = "Shadow's Emissary";
  titles[-67000] = "Black-Hearted Fiend";
  titles[-66000] = "Sinister Manipulator";
  titles[-65000] = "Merciless Destroyer";
  titles[-64000] = "Twisted Corruptor";
  titles[-63000] = "Heinous Oppressor";
  titles[-62000] = "Desolation Bringer";
  titles[-61000] = "Fell Commander";
  titles[-60000] = "Ruination's Herald";
  titles[-59000] = "Contemptuous Slaver";
  titles[-58000] = "Nefarious Schemer";
  titles[-57000] = "Abhorrent Defiler";
  titles[-56000] = "Malignant Presence";
  titles[-55000] = "Insidious Deceiver";
  titles[-54000] = "Odious Tormentor";
  titles[-53000] = "Atrocity's Champion";
  titles[-52000] = "Glorified Villain";
  titles[-51000] = "Vicious Tormenter";
  titles[-50000] = "Lord of Malice";
  titles[-49000] = "Callous Brutalizer";
  titles[-48000] = "Vindictive Oppressor";
  titles[-47000] = "Ruthless Executor";
  titles[-46000] = "Depraved Hunter";
  titles[-45000] = "Baleful Overseer";
  titles[-44000] = "Remorseless Butcher";
  titles[-43000] = "Grim Torturer";
  titles[-42000] = "Pestilence Walker";
  titles[-41000] = "Iniquitous Despot";
  titles[-40000] = "Master of Evil";
  titles[-39000] = "Soulless Predator";
  titles[-38000] = "Grievous Antagonist";
  titles[-37000] = "Hateful Subjugator";
  titles[-36000] = "Pain Monger";
  titles[-35000] = "Spiteful Persecutor";
  titles[-34000] = "Bane of Innocence";
  titles[-33000] = "Notorious Villain";
  titles[-32000] = "Unrepentant Criminal";
  titles[-31000] = "Fear Merchant";
  titles[-30000] = "Dark Overlord";
  titles[-29000] = "Nether Servant";
  titles[-28000] = "Corrupt Dictator";
  titles[-27000] = "Malicious Opportunist";
  titles[-26000] = "Callous Exploiter";
  titles[-25000] = "Glorious Villain";
  titles[-24000] = "Hardened Tyrant";
  titles[-23000] = "Calculating Manipulator";
  titles[-22000] = "Unforgiving Executioner";
  titles[-21000] = "Merciless Oppressor";
  titles[-20000] = "Agent of Darkness";
  titles[-19000] = "Ruthless Enforcer";
  titles[-18000] = "Devious Conspirator";
  titles[-17000] = "Dishonorable Rogue";
  titles[-16000] = "Feared Despot";
  titles[-15000] = "Amoral Predator";
  titles[-14000] = "Heartless Operator";
  titles[-13000] = "Vile Despoiler";
  titles[-12000] = "Corrupt Official";
  titles[-11000] = "Treacherous Betrayer";
  titles[-10000] = "Servant of Evil";
  titles[-9000] = "Depraved Miscreant";
  titles[-8000] = "Malevolent Schemer";
  titles[-7000] = "Opportunistic Villain";
  titles[-6000] = "Despicable Rogue";
  titles[-5000] = "Immoral Profiteer";
  titles[-3500] = "Disreputable Scoundrel";
  titles[-2000] = "Unprincipled Deceiver";
  titles[-500] = "Shameless Exploiter";
  titles[-100] = "Moral Defiler";

  // Neutral alignments (0)
  titles[0] = "True Neutral";

  // Good alignments (+1000 to +100000)
  titles[100] = "Moral Dabbler";
  titles[500] = "Occasional Altruist";
  titles[2000] = "Ethical Aspirant";
  titles[3500] = "Budding Samaritan";
  titles[5000] = "Emerging Benefactor";
  titles[6000] = "Decent Soul";
  titles[7000] = "Moral Novice";
  titles[8000] = "Fledgling Virtuous";
  titles[9000] = "Developing Altruist";
  titles[10000] = "Servant of Good";
  titles[11000] = "Principled Citizen";
  titles[12000] = "Honorable Associate";
  titles[13000] = "Kind Supporter";
  titles[14000] = "Considerate Helper";
  titles[15000] = "Moral Practitioner";
  titles[16000] = "Noble Commoner";
  titles[17000] = "Righteous Advocate";
  titles[18000] = "Benevolent Assistant";
  titles[19000] = "Compassionate Ally";
  titles[20000] = "Agent of Light";
  titles[21000] = "Merciful Guardian";
  titles[22000] = "Charitable Steward";
  titles[23000] = "Stalwart Defender";
  titles[24000] = "Dedicated Protector";
  titles[25000] = "Glorious Champion";
  titles[26000] = "Virtuous Exemplar";
  titles[27000] = "Benign Custodian";
  titles[28000] = "Ethical Paragon";
  titles[29000] = "Valorous Knight";
  titles[30000] = "Beacon of Hope";
  titles[31000] = "Light Bringer";
  titles[32000] = "Righteous Defender";
  titles[33000] = "Honorable Guardian";
  titles[34000] = "Steadfast Protector";
  titles[35000] = "Blessed Sentinel";
  titles[36000] = "Mercy's Voice";
  titles[37000] = "Noble Vanguard";
  titles[38000] = "Luminous Shepherd";
  titles[39000] = "Selfless Benefactor";
  titles[40000] = "Master of Good";
  titles[41000] = "Valiant Crusader";
  titles[42000] = "Illustrious Benefactor";
  titles[43000] = "Virtuous Shepherd";
  titles[44000] = "Resplendent Exemplar";
  titles[45000] = "Gracious Overseer";
  titles[46000] = "Magnanimous Protector";
  titles[47000] = "Radiant Vanguard";
  titles[48000] = "Blessed Guardian";
  titles[49000] = "Virtuous Paragon";
  titles[50000] = "Lord of Virtue";
  titles[51000] = "Honorable Paragon";
  titles[52000] = "Transcendent Champion";
  titles[53000] = "Luminous Protector";
  titles[54000] = "Beacon of Virtue";
  titles[55000] = "Exalted Guardian";
  titles[56000] = "Divine Emissary";
  titles[57000] = "Radiant Champion";
  titles[58000] = "Hallowed Defender";
  titles[59000] = "Exalted Sentinel";
  titles[60000] = "Herald of Light";
  titles[61000] = "Celestial Guardian";
  titles[62000] = "Sublime Vanguard";
  titles[63000] = "Virtuous Exemplar";
  titles[64000] = "Divine Guardian";
  titles[65000] = "Brilliant Paragon";
  titles[66000] = "Sanctified Champion";
  titles[67000] = "Exalted Herald";
  titles[68000] = "Empyreal Defender";
  titles[69000] = "Heavenly Shepherd";
  titles[70000] = "Celestial Paragon";
  titles[71000] = "Luminary of Virtue";
  titles[72000] = "Sanctified Protector";
  titles[73000] = "Radiant Sovereign";
  titles[74000] = "Divine Steward";
  titles[75000] = "Immaculate Champion";
  titles[76000] = "Blessed Luminary";
  titles[77000] = "Transcendent Guardian";
  titles[78000] = "Sublime Protector";
  titles[79000] = "Celestial Sentinel";
  titles[80000] = "Divine Exemplar";
  titles[81000] = "Hallowed Paragon";
  titles[82000] = "Radiant Emissary";
  titles[83000] = "Exalted Avatar";
  titles[84000] = "Celestial Shepherd";
  titles[85000] = "Transcendent Light";
  titles[86000] = "Divine Vanguard";
  titles[87000] = "Sanctified Emissary";
  titles[88000] = "Celestial Beacon";
  titles[89000] = "Transcendent Virtue";
  titles[90000] = "Paragon of Virtue";
  titles[99000] = "Saint of Light";
  titles[100000] = "Divine Embodiment";
  
  return titles;
};

// Generate the titles and make sure it's executed
const alignmentTitles = generateAlignmentTitles();

/**
 * Calculate absolute alignment value from good, neutral, and evil components
 */
export const calculateAlignmentValue = (good, neutral, evil) => {
  // Fix: Handle 0 properly by using explicit number conversion
  good = Number(good) || 0;
  neutral = Number(neutral) || 0;
  evil = Number(evil) || 0;
  
  // Debug the incoming values
  console.log('Calculating alignment from:', { good, neutral, evil });
  
  // If all values are 0, return pure neutral (0)
  const total = good + neutral + evil;
  if (total === 0) return 0;
  
  // Use a simpler formula for more predictable results
  // This computes the weighted alignment based on good vs evil values
  let alignmentValue = Math.round(((good - evil) / total) * (good + evil));
  
  // Add bounds to prevent extreme values
  alignmentValue = Math.max(-100000, Math.min(100000, alignmentValue));
  
  console.log('Calculated alignment value:', alignmentValue);
  return alignmentValue;
};

/**
 * Find the closest alignment title for a given alignment value
 */
export const getAlignmentTitle = (alignment) => {
  // Handle null/undefined alignment
  if (!alignment) {
    console.log('Alignment object is null or undefined');
    return "True Neutral";
  }
  
  // Calculate alignment value if object was passed
  let alignmentValue;
  if (typeof alignment === 'object' && alignment !== null) {
    const good = Number(alignment.good) || 0;
    const neutral = Number(alignment.neutral) || 0;
    const evil = Number(alignment.evil) || 0;
    alignmentValue = calculateAlignmentValue(good, neutral, evil);
  } else {
    alignmentValue = Number(alignment) || 0;
  }
  
  // Log for debugging
  console.log('Finding title for alignment value:', alignmentValue);
  
  // Get all available alignment values from the titles object
  const values = Object.keys(alignmentTitles)
    .map(Number)
    .filter(v => !isNaN(v))  // Filter out any invalid values
    .sort((a, b) => a - b);
  
  // If no values are available, default to neutral
  if (values.length === 0) {
    console.error('No alignment titles defined!');
    return "True Neutral";
  }
  
  // Exact match check
  if (alignmentTitles[alignmentValue] !== undefined) {
    return alignmentTitles[alignmentValue];
  }
  
  // Find closest match using binary search approach
  if (alignmentValue <= values[0]) return alignmentTitles[values[0]];
  if (alignmentValue >= values[values.length - 1]) return alignmentTitles[values[values.length - 1]];
  
  // Find the largest value that's less than or equal to our target
  let closestValue = values[0];
  for (const value of values) {
    if (value <= alignmentValue && value > closestValue) {
      closestValue = value;
    }
  }
  
  console.log('Selected title key:', closestValue, 'Title:', alignmentTitles[closestValue]);
  return alignmentTitles[closestValue];
};

/**
 * Get color based on alignment value
 * 
 * @param {number|Object} alignment - The character's alignment value or object with good/neutral/evil properties
 * @returns {string} - CSS color value
 */
export const getAlignmentColor = (alignment) => {
  // Calculate alignment value as in getAlignmentTitle
  let alignmentValue;
  if (typeof alignment === 'object' && alignment !== null) {
    alignmentValue = calculateAlignmentValue(
      Number(alignment.good) || 0,
      Number(alignment.neutral) || 0,
      Number(alignment.evil) || 0
    );
  } else {
    alignmentValue = Number(alignment) || 0;
  }
  
  // Return color based on value
  if (alignmentValue > 0) return '#6cdb8e'; // Good color
  if (alignmentValue < 0) return '#ff6b6b'; // Evil color
  return '#f5d76e'; // Neutral color
};

// Export the titles object as well
export default alignmentTitles;